import classNames from 'classnames';
import styles from './BundleSelectorItem.scss';
import WoWSEntity from '@wg/wows-entities/wrappers/react/WoWSEntity';
import { PresentationStyles } from '@wg/wows-entities/const';
import { playButtonClickSound } from '@wg/web2clientapi/sound';
import { CSSProperties } from 'react';

export interface IBundleSelectorItem {
    bundle: IBundle;
    isSelected: boolean;
    index: number;
    onClick: (n: number) => void;
}

const BundleSelectorItem = ({ bundle, isSelected, index, onClick }: IBundleSelectorItem) => {
    const classesCard = classNames(styles.card, {
        [styles.selected]: isSelected,
    });

    const onClickHandler = () => {
        playButtonClickSound();
        onClick(index);
    };

    const style: CSSProperties = { animationDelay: `${(index + 1) * 100}ms` };

    return (
        <div className={classesCard} onClick={onClickHandler} style={style}>
            <div className={styles.background} style={{ backgroundImage: `url(${bundle.icons.medium})` }} />
            <div className={styles.header}>
                <div className={styles.title}>
                    <WoWSEntity
                        type={bundle.primaryItem.type}
                        id={bundle.primaryItem.identifier}
                        presentation={{
                            renderWithoutFade: true,
                            withText: false,
                        }}
                    />
                </div>
                <div className={styles.subTitle}>
                    <WoWSEntity
                        id={bundle.primaryItem.identifier}
                        type={bundle.primaryItem.type}
                        key={`bundle_${bundle.id}_ship_${bundle.primaryItem.identifier}`}
                        presentation={{
                            style: PresentationStyles.TYPE,
                            renderWithoutFade: true,
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default BundleSelectorItem;
